import React from 'react';
import { useIntl } from 'react-intl';
import { GIButton } from 'app-components';
import { Text } from '@components/common/form';
import { ConditionalRendering } from '@modules/members/utils';
import MediaPlayer from './components/MediaPlayer';
import { ContentIds } from './constants/media.interface';
import { FlexContainer, StyledFlexContainerWithBorder, StyledTranscriptionDiv, FlexRow, StyledDiv, StyledInteractionHeading, StyledGridContainer } from './constants/media.styled';

interface MediaDataProps {
    interactionId?: string;
    mediaData?: {
        mediaUrl?: string;
        interaction?: string;
        transcription?: string;
    };
    fromAccountActivity?: boolean;
}

interface IMediaContentProps {
    contentData: {
        id: string;
        props: MediaDataProps;
    };
    setContentData: React.Dispatch<React.SetStateAction<{ id: string; props: MediaDataProps }>>;
}

const MediaContent = ({ contentData, setContentData }: IMediaContentProps) => {
    const intl = useIntl();
    const formatMessage = intl.formatMessage;
    const { interactionId, mediaData, fromAccountActivity } = contentData.props || {};

    const onBack = () => {
        setContentData({ id: ContentIds.MEDIA_FORM, props: {} });
    };

    return (
        <FlexContainer data-testid='media-content'>
            <FlexRow className='justify-content-center' data-testid='media-content-header' style={{gap: 80}}>
                <StyledInteractionHeading data-testid='interaction-id-heading'>
                    {`${formatMessage({ id: 'cap.mediaAccess.label.interactionId' })}: ${interactionId}`}
                </StyledInteractionHeading>
            </FlexRow>
            <StyledGridContainer>
                <FlexContainer className='flex-1'>
                    <ConditionalRendering isTrue={!!mediaData?.mediaUrl}>
                        <StyledDiv className='media-player-container'>
                            <MediaPlayer mediaUrl={mediaData?.mediaUrl || ''} disableDownload />
                        </StyledDiv>
                    </ConditionalRendering>
                    <StyledFlexContainerWithBorder className='dataSyncHtml'>
                        <ConditionalRendering isTrue={!!mediaData?.interaction}>
                            <StyledDiv data-testid='interaction-content' className='interactionContent' dangerouslySetInnerHTML={{ __html: mediaData?.interaction || '' }} />
                        </ConditionalRendering>
                        <ConditionalRendering isTrue={!mediaData?.interaction}>
                            <Text id='chat-not-available' text={'cap.mediaAccess.message.chatVATextNotAvailable'} />
                        </ConditionalRendering>
                    </StyledFlexContainerWithBorder>
                </FlexContainer>
                <StyledFlexContainerWithBorder className='flex-1 dataSyncHtml'>
                    <ConditionalRendering isTrue={!!mediaData?.transcription}>
                        <StyledTranscriptionDiv data-testid='transcription-content' dangerouslySetInnerHTML={{ __html: mediaData?.transcription || '' }} />
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={!mediaData?.transcription}>
                        <Text id='transcription-not-available' text={'cap.mediaAccess.message.analyticsTranscriptionNotAvailable'} />
                    </ConditionalRendering>
                </StyledFlexContainerWithBorder>
            </StyledGridContainer>
            <ConditionalRendering isTrue={!fromAccountActivity}>
                <FlexContainer className='align-items-end'>
                    <GIButton
                        id='backButton'
                        onClickHandler={onBack}
                        label={formatMessage({ id: 'cap.mediaAccess.button.back' })}
                        variant='secondary'
                    />
                </FlexContainer>
            </ConditionalRendering>
        </FlexContainer>
    );
};

export default MediaContent;